module.exports = __webpack_public_path__ + "media/customizations/crosscreek/back-266168ee4cf0fbc30f0cc660eea85261.jpg";